<mat-form-field [ngClass]="{ 'element--disabled-grey': disabled }">
  <mat-select [(value)]="selectedOption" class="sorting-select" (selectionChange)="onSelectionChange($event.value)"
    [disabled]="disabled">
    @for (option of optionList; track option.value) {
      <mat-option [value]="option.value">
        {{ option.viewValue }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>